import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from '@phosphor-icons/react';
import LandingNav from './LandingNav';
import LandingFooter from './LandingFooter';
import SEO from '../../components/SEO';
import { blogPosts } from '../../data/blogPosts';

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-primaryB-50 overflow-x-hidden">
      <SEO
        title="Blog – POS Software Tips &amp; Guides for African Businesses"
        description="Guides, tips, and insights on POS software for African businesses. Learn how to choose the right point of sale system for Ghana, Nigeria, and across Africa."
        path="/blog"
        keywords="pos software blog africa, pos tips africa, business software guides ghana, pos guides nigeria, point of sale africa blog, software solutions africa"
      />
      <LandingNav />

      <section className="pt-24 sm:pt-32 lg:pt-40 pb-16 sm:pb-20">
        <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8">
          <div className="mb-12 sm:mb-16">
            <p className="text-emerald-600 text-xs font-bold tracking-widest uppercase mb-3">Blog</p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-primaryB-900 mb-3 leading-tight">
              POS software guides for{' '}
              <span className="italic text-emerald-600">African businesses</span>.
            </h1>
            <p className="text-primaryB-500 text-base sm:text-lg">
              Practical advice on choosing and using POS software across Ghana, Nigeria, and Africa.
            </p>
          </div>

          <div className="space-y-5">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group block bg-white border border-primaryB-200/60 rounded-2xl p-6 sm:p-8 hover:border-primaryB-300/80 hover:shadow-card transition-all duration-200"
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-primaryB-300 text-xs font-medium">{post.date}</span>
                  <span className="w-1 h-1 rounded-full bg-primaryB-200" />
                  <span className="flex items-center gap-1 text-primaryB-300 text-xs font-medium">
                    <Clock weight="bold" className="w-3 h-3" />
                    {post.readTime}
                  </span>
                </div>
                <h2 className="text-lg sm:text-xl font-extrabold text-primaryB-900 mb-2 group-hover:text-emerald-700 transition-colors duration-200">
                  {post.title}
                </h2>
                <p className="text-primaryB-500 text-sm leading-relaxed mb-4">
                  {post.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-emerald-600 text-sm font-semibold group-hover:gap-2.5 transition-all duration-200">
                  Read article <ArrowRight weight="bold" className="w-4 h-4" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
};

export default BlogPage;
